/* PŪNGAO: dynamic % OFF badges — per-variant mapping + mobile-safe + reorder plans + OTP badge + mobile price stack */
(function(){
  /* =====================  CONFIG (EDIT THESE NUMBERS)  ===================== */

  /* First order % shown in the yellow Subscribe badge AND the first bullet
     Map: VARIANT_ID => percent */
  var SUB_FIRST_PCT_BY_ID = {
    // ORIGINAL Vital Nectar (VN)
    "44720092872860": 20, // 12-pack
    "44720092905628": 24, // 24-pack
    "44720092938396": 28, // 48-pack

    // LEMON Vital Nectar (VN)
    "46659982164124": 20, // 12-pack
    "46659982196892": 24, // 24-pack
    "46659982229660": 28, // 48-pack

    // RASPBERRY Vital Nectar (VN)
    "46949923029148": 20, // 12-pack
    "46949923061916": 24, // 24-pack
    "46949923094684": 28, // 48-pack

    // ORIGINAL Kinesis Nectar (KN)
    "45210595098780": 20, // 12-pack
    "45210595131548": 24, // 24-pack
    "45210595164316": 28, // 48-pack

    // LEMON Kinesis Nectar (KN)
    "47316097466524": 20, // 12-pack
    "47316097499292": 24, // 24-pack
    "47316097532060": 28, // 48-pack

    // RASPBERRY Kinesis Nectar (KN)
    "47257820692636": 20, // 12-pack
    "47257820725404": 24, // 24-pack
    "47257820758172": 28, // 48-pack

    // Bundle ORIGINAL VN + ORIGINAL KN / Sets (update to your exact math)
    "45210604404892": 24, // 1 set
    "45210604437660": 28, // 2 sets
    "45210604470428": 36, // 4 sets

    // Bundle ORIGINAL VN + RASPBERRY KN / Sets (update to your exact math)
    "47257951109276": 24, // 1 set
    "47257951142044": 28, // 2 sets
    "47257951174812": 36, // 4 sets

    // Bundle ORIGINAL VN + LEMON KN / Sets (update to your exact math)
    "47316130889884": 24, // 1 set
    "47316130922652": 28, // 2 sets
    "47316130955420": 36, // 4 sets

    // Bundle LEMON VN + ORIGINAL KN / Sets (update to your exact math)
    "46660005363868": 24, // 1 set
    "46660005396636": 28, // 2 sets
    "46660005429404": 36, // 4 sets

    // Bundle LEMON VN + RASPBERRY KN / Sets (update to your exact math)
    "47257950912668": 24, // 1 set
    "47257950945436": 28, // 2 sets
    "47257950978204": 36, // 4 sets

    // Bundle LEMON VN + LEMON KN / Sets (update to your exact math)
    "47316130693276": 24, // 1 set
    "47316130726044": 28, // 2 sets
    "47316130758812": 36, // 4 sets

    // Bundle RASPBERRY VN + ORIGINAL KN / Sets (update to your exact math)
    "46949943574684": 24, // 1 set
    "46949943607452": 28, // 2 sets
    "46949943640220": 36, // 4 sets

    // Bundle RASPBERRY VN + RASPBERRY KN / Sets (update to your exact math)
    "47257951010972": 24, // 1 set
    "47257951043740": 28, // 2 sets
    "47257951076508": 36, // 4 sets

    // Bundle RASPBERRY VN + LEMON KN / Sets (update to your exact math)
    "47316130791580": 24, // 1 set
    "47316130824348": 28, // 2 sets
    "47316130857116": 36, // 4 sets

    // Vital Flavor Sampler (Lemon + Raspberry) / Sets (update to your exact math)
    "46875516698780": 24, // 1 set
    "46875516731548": 28, // 2 sets
    "46875516764316": 36, // 4 sets

    // Kinesis Flavor Sampler (Lemon + Raspberry) / Sets (update to your exact math)
    "47190323265692": 24, // 1 set
    "47190323298460": 28, // 2 sets
    "47190323331228": 36, // 4 sets

    // Vital Trio / Sets (update to your exact math)
    "46875501265052": 26, // 1 set
    "46875501297820": 32, // 2 sets

    // Kinesis Trio / Sets (update to your exact math)
    "47184043278492": 26, // 1 set
    "47184043311260": 32, // 2 sets

    // Whole Hive Bundle / Sets (update to your exact math)
    "47316596523164": 32, // 1 set
    "47316596555932": 44, // 2 sets

    // VN Sampler Pack (old) / Sets (update to your exact math)
    "46622266491036": 24, // 1 set
    "46622266523804": 28, // 2 sets
    "46622266556572": 36  // 4 sets
  };

  /* Recurring % shown in the second bullet (“every order after”)
     Map: VARIANT_ID => percent */
  var SUB_RECUR_PCT_BY_ID = {
    // ORIGINAL Vital Nectar (VN)
    "44720092872860": 10, // 12-pack
    "44720092905628": 15, // 24-pack
    "44720092938396": 19, // 48-pack

    // LEMON Vital Nectar (VN)
    "46659982164124": 10, // 12-pack
    "46659982196892": 15, // 24-pack
    "46659982229660": 19, // 48-pack

    // RASPBERRY Vital Nectar (VN)
    "46949923029148": 10, // 12-pack
    "46949923061916": 15, // 24-pack
    "46949923094684": 19, // 48-pack

    // ORIGINAL Kinesis Nectar (KN)
    "45210595098780": 10, // 12-pack
    "45210595131548": 15, // 24-pack
    "45210595164316": 19, // 48-pack

    // LEMON Kinesis Nectar (KN)
    "47316097466524": 10, // 12-pack
    "47316097499292": 15, // 24-pack
    "47316097532060": 19, // 48-pack

    // RASPBERRY Kinesis Nectar (KN)
    "47257820692636": 10, // 12-pack
    "47257820725404": 15, // 24-pack
    "47257820758172": 19, // 48-pack

    // Bundle ORIGINAL VN + ORIGINAL KN / Sets (update to your exact math)
    "45210604404892": 15, // 1 set
    "45210604437660": 19, // 2 sets
    "45210604470428": 28, // 4 sets

    // Bundle ORIGINAL VN + RASPBERRY KN / Sets (update to your exact math)
    "47257951109276": 15, // 1 set
    "47257951142044": 19, // 2 sets
    "47257951174812": 28, // 4 sets

    // Bundle ORIGINAL VN + LEMON KN / Sets (update to your exact math)
    "47316130889884": 15, // 1 set
    "47316130922652": 19, // 2 sets
    "47316130955420": 28, // 4 sets

    // Bundle LEMON VN + ORIGINAL KN / Sets (update to your exact math)
    "46660005363868": 15, // 1 set
    "46660005396636": 19, // 2 sets
    "46660005429404": 28, // 4 sets

    // Bundle LEMON VN + RASPBERRY KN / Sets (update to your exact math)
    "47257950912668": 15, // 1 set
    "47257950945436": 19, // 2 sets
    "47257950978204": 28, // 4 sets

    // Bundle LEMON VN + LEMON KN / Sets (update to your exact math)
    "47316130693276": 15, // 1 set
    "47316130726044": 19, // 2 sets
    "47316130758812": 28, // 4 sets

    // Bundle RASPBERRY VN + ORIGINAL KN / Sets (update to your exact math)
    "46949943574684": 15, // 1 set
    "46949943607452": 19, // 2 sets
    "46949943640220": 28, // 4 sets

    // Bundle RASPBERRY VN + RASPBERRY KN / Sets (update to your exact math)
    "47257951010972": 15, // 1 set
    "47257951043740": 19, // 2 sets
    "47257951076508": 28, // 4 sets

    // Bundle RASPBERRY VN + LEMON KN / Sets (update to your exact math)
    "47316130791580": 15, // 1 set
    "47316130824348": 19, // 2 sets
    "47316130857116": 28, // 4 sets

    // Vital Flavor Sampler (Lemon + Raspberry) / Sets (update to your exact math)
    "46875516698780": 15, // 1 set
    "46875516731548": 19, // 2 sets
    "46875516764316": 28, // 4 sets

    // Kinesis Flavor Sampler (Lemon + Raspberry) / Sets (update to your exact math)
    "47190323265692": 15, // 1 set
    "47190323298460": 19, // 2 sets
    "47190323331228": 28, // 4 sets

    // Vital Trio / Sets (update to your exact math)
    "46875501265052": 17, // 1 set
    "46875501297820": 24, // 2 sets

    // Kinesis Trio / Sets (update to your exact math)
    "47184043278492": 17, // 1 set
    "47184043311260": 24, // 2 sets

    // Whole Hive Bundle / Sets (update to your exact math)
    "47316596523164": 24, // 1 set
    "47316596555932": 37, // 2 sets

    // VN Sampler Pack (old) / Sets (update to your exact math)
    "46622266491036": 15, // 1 set
    "46622266523804": 19, // 2 sets
    "46622266556572": 28  // 4 sets
  };

  /* One-time badge % by pack (used for the transparent badge) */
  var ONE_TIME_PCT = { "12": 0, "24": 5, "48": 10, "1": 5, "2": 10, "4": 20, "5": 8, "6": 15, "7": 30 };

  /* Pack code per VARIANT_ID (used for OTP badge + fallbacks) */
  var PACK_BY_ID = {
    // ORIGINAL Vital Nectar (VN)
    "44720092872860": "12",
    "44720092905628": "24",
    "44720092938396": "48",

    // LEMON Vital Nectar (VN)
    "46659982164124": "12",
    "46659982196892": "24",
    "46659982229660": "48",

    // RASPBERRY Vital Nectar (VN)
    "46949923029148": "12",
    "46949923061916": "24",
    "46949923094684": "48",

    // ORIGINAL Kinesis Nectar (KN)
    "45210595098780": "12",
    "45210595131548": "24",
    "45210595164316": "48",

    // LEMON Kinesis Nectar (KN)
    "47316097466524": "12",
    "47316097499292": "24",
    "47316097532060": "48",

    // RASPBERRY Kinesis Nectar (KN)
    "47257820692636": "12",
    "47257820725404": "24",
    "47257820758172": "48",

    // Bundle ORIGINAL VN + ORIGINAL KN / Sets
    "45210604404892": "1",
    "45210604437660": "2",
    "45210604470428": "4",

    // Bundle ORIGINAL VN + RASPBERRY KN / Sets
    "47257951109276": "1",
    "47257951142044": "2",
    "47257951174812": "4",

    // Bundle ORIGINAL VN + LEMON KN / Sets (update to your exact math)
    "47316130889884": "1",
    "47316130922652": "2",
    "47316130955420": "4",

    // Bundle LEMON VN + ORIGINAL KN / Sets
    "46660005363868": "1",
    "46660005396636": "2",
    "46660005429404": "4",

    // Bundle LEMON VN + RASPBERRY KN / Sets (update to your exact math)
    "47257950912668": "1",
    "47257950945436": "2",
    "47257950978204": "4",

    // Bundle LEMON VN + LEMON KN / Sets (update to your exact math)
    "47316130693276": "1",
    "47316130726044": "2",
    "47316130758812": "4",

    // Bundle RASPBERRY VN + ORIGINAL KN / Sets
    "46949943574684": "1",
    "46949943607452": "2",
    "46949943640220": "4",

    // Bundle RASPBERRY VN + RASPBERRY KN / Sets (update to your exact math)
    "47257951010972": "1",
    "47257951043740": "2",
    "47257951076508": "4",

    // Bundle RASPBERRY VN + LEMON KN / Sets (update to your exact math)
    "47316130791580": "1",
    "47316130824348": "2",
    "47316130857116": "4",

    // Vital Flavor Sampler (Lemon + Raspberry) / Sets
    "46875516698780": "1",
    "46875516731548": "2",
    "46875516764316": "4",

    // Kinesis Flavor Sampler (Lemon + Raspberry) / Sets (update to your exact math)
    "47190323265692": "1",
    "47190323298460": "2",
    "47190323331228": "4",

    // Vital Trio / Sets
    "46875501265052": "5",
    "46875501297820": "6",

    // Kinesis Trio / Sets (update to your exact math)
    "47184043278492": "5",
    "47184043311260": "6",

    // Whole Hive Bundle / Sets (update to your exact math)
    "47316596523164": "6", // 1 set
    "47316596555932": "7", // 2 sets

    // VN Sampler Pack (old) / Sets
    "46622266491036": "1",
    "46622266523804": "2",
    "46622266556572": "4"
  };

  /* ========================================================================= */

  function $all(sel, root){ return (root||document).querySelectorAll(sel); }

  function findContextRoot(from){
    return from.closest('[data-section-id], .ec-section, [data-ecomp-section]') ||
           from.closest('[data-bundleapp-wrapper], .bundleapp-wrapper')       ||
           from.closest('form[action*="/cart/add"]')                           ||
           document;
  }

  function nearestFormFor(node, fallbackRoot){
    var form = node.closest('form[action*="/cart/add"]');
    if (form) return form;
    if (fallbackRoot){
      form = fallbackRoot.querySelector('form[action*="/cart/add"]');
      if (form) return form;
    }
    var forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
    if (!forms.length) return null;

    var b = node.getBoundingClientRect(), bx = b.left + b.width/2, by = b.top + b.height/2;
    var best = null, bestD = Infinity;
    forms.forEach(function(f){
      var r = f.getBoundingClientRect(), fx = r.left + r.width/2, fy = r.top + r.height/2;
      var d = Math.hypot(fx - bx, fy - by);
      if (d < bestD){ bestD = d; best = f; }
    });
    return best;
  }

  function currentVariantIdFrom(form, root){
    var hid = form && form.querySelector('input[name="id"]');          if (hid && hid.value) return hid.value;
    var sel = form && form.querySelector('select[name="id"]');         if (sel && sel.value) return sel.value;
    var any = root && root.querySelector('[data-variant-id]');         if (any && any.getAttribute('data-variant-id')) return any.getAttribute('data-variant-id');
    try { if (window.ShopifyAnalytics?.meta?.selectedVariantId) return String(ShopifyAnalytics.meta.selectedVariantId); } catch(e){}
    var m = location.search.match(/[?&]variant=(\d+)/);                 if (m) return m[1];
    return null;
  }

  function detectPackCodeFromUI(form, root){
    var opt = form && form.querySelector('select[name="id"] option:checked');
    if (opt && opt.text){ var m = opt.text.match(/\b(12|24|48|1|2|4)\b/); if (m) return m[1]; }
    var sw = (root && (root.querySelector('.ecom-product-single__swatch-item.selected, .ecom-product-single__swatch-item.is-active, [role="radio"][aria-checked="true"]')))
          || (form && (form.querySelector('.selected, .is-active, [aria-checked="true"]')));
    if (sw){
      var val = sw.getAttribute('data-value') || sw.textContent || '';
      var m2 = String(val).match(/\b(12|24|48|1|2|4)\b/); if (m2) return m2[1];
    }
    var txt = (root && root.textContent) || '';
    var m3 = String(txt).match(/\b(12|24|48|1|2|4)\b/);   if (m3) return m3[1];
    return null;
  }

  function computeOTPPercent(code){ return code ? (ONE_TIME_PCT[code] || 0) : 0; }

  /* ---------- UI helpers ---------- */

  // Transparent OTP badge CSS + create badge span in One-time row
  function ensureBadges(){
    if (!document.getElementById('pungao-otp-badge-css')){
      var css = document.createElement('style');
      css.id = 'pungao-otp-badge-css';
      css.textContent =
        '[data-bfcm-badge-otp]{display:inline-block;margin-left:5px;padding:0px 6px;border:2px solid;border-radius:12px;background:transparent;font-weight:800;line-height:1;}' +
        '@media (max-width:520px){[data-bfcm-badge-otp]{padding:0px 6px;border-width:2px;border-radius:12px;}}' +

        /* price stack wrapper (inline on desktop, stacked on mobile) */
        '.pungao-price-stack{display:inline-flex;align-items:flex-end;gap:6px;}' +
        '@media (max-width:520px){.pungao-price-stack{display:flex;flex-direction:column;align-items:flex-end;gap:2px;}}' +
        '@media (max-width:520px){.pungao-price-stack .pg-price{font-size:16px;font-weight:700;line-height:1.1;}}' +
        '@media (max-width:520px){.pungao-price-stack .pg-compare{font-size:13px;opacity:.8;}}';
      document.head.appendChild(css);
    }

    $all('[data-bundleapp-wrapper], .bundleapp-wrapper').forEach(function(wrap){
      var one = wrap.querySelector('.bundleapp-plan-selector-group[data-one-time]');
      if (one){
        var label = one.querySelector('label');
        if (label && !label.querySelector('[data-bfcm-badge-otp]')){
          var badge = document.createElement('span');
          badge.setAttribute('data-bfcm-badge-otp','');
          badge.textContent = '—';
          var priceSpan = label.querySelector('.bundleapp-plan-selector-group-pricing');
          if (priceSpan) label.insertBefore(badge, priceSpan);
          else label.appendChild(badge);
        }
      }
    });
  }

  // Wrap the compare + price into one container we can stack on mobile
  function ensurePriceStack(){
    document.querySelectorAll('[data-bundleapp-wrapper] .bundleapp-plan-selector-group label, .bundleapp-wrapper .bundleapp-plan-selector-group label').forEach(function(label){
      if (label.querySelector('.pungao-price-stack')) return;

      var price  = label.querySelector('.bundleapp-plan-selector-group-pricing');
      var cmpBox = label.querySelector('.bundleapp-plan-selector-group-compare, .bundleapp-plan-selector-group-onetime-compare');
      if (!price || !cmpBox) return;

      // kill stray text nodes (e.g., &nbsp;)
      Array.from(cmpBox.childNodes).forEach(function(n){
        if (n.nodeType === 3 && !n.textContent.replace(/\u00A0/g,'').trim()){
          cmpBox.removeChild(n);
        }
      });

      cmpBox.classList.add('pg-compare');
      price.classList.add('pg-price');

      var wrap = document.createElement('span');
      wrap.className = 'pungao-price-stack';
      price.parentNode.insertBefore(wrap, price);
      wrap.appendChild(cmpBox);
      wrap.appendChild(price);

      cmpBox.style.textAlign = 'right';
    });
  }

  /* ---- benefit bullets updater (per-variant) ---- */
  function firstSubscribePercentForVariant(variantId, fallbackCode){
    if (variantId && SUB_FIRST_PCT_BY_ID[variantId] != null) return SUB_FIRST_PCT_BY_ID[variantId];
    return 0;
  }
  function recurringSubscribePercentForVariant(variantId, fallbackCode){
    if (variantId && SUB_RECUR_PCT_BY_ID[variantId] != null) return SUB_RECUR_PCT_BY_ID[variantId];
    return 0;
  }

  function updateBenefitPercents(){
    document.querySelectorAll('[data-bundleapp-wrapper], .bundleapp-wrapper').forEach(function(wrap){
      var form = nearestFormFor(wrap, wrap) || document;
      var vid  = currentVariantIdFrom(form, wrap);
      var code = vid ? PACK_BY_ID[vid] : detectPackCodeFromUI(form, wrap);

      var firstPct = firstSubscribePercentForVariant(vid, code);
      var recurPct = recurringSubscribePercentForVariant(vid, code);

      var firstEl = wrap.querySelector('[data-sub-first]');
      var recurEl = wrap.querySelector('[data-sub-recurring]');
      if (firstEl) firstEl.textContent = String(firstPct);
      if (recurEl) recurEl.textContent = String(recurPct);
    });
  }

  /* ---------- calculations + updates ---------- */
  function updateAllBadges(){
    ensureBadges();
    ensurePriceStack();

    // SUBSCRIBE badge — show FIRST order percent from manual map
    $all('[data-bfcm-badge]').forEach(function(badge){
      var root = findContextRoot(badge);
      var form = nearestFormFor(badge, root) || document;
      var vid  = currentVariantIdFrom(form, root);
      var code = vid ? PACK_BY_ID[vid] : detectPackCodeFromUI(form, root);
      var pct  = firstSubscribePercentForVariant(vid, code);
      badge.textContent = pct + '% OFF';
    });

    // ONE-TIME badges (hide when no discount, e.g., 12-pack)
    $all('[data-bfcm-badge-otp]').forEach(function(badge){
      var root = findContextRoot(badge);
      var form = nearestFormFor(badge, root) || document;
      var vid  = currentVariantIdFrom(form, root);
      var code = vid ? PACK_BY_ID[vid] : detectPackCodeFromUI(form, root);
      var pct  = computeOTPPercent(code);

      if (pct && pct > 0) {
        badge.style.display = 'inline-block';
        badge.setAttribute('aria-hidden', 'false');
        badge.textContent = pct + '% OFF';
      } else {
        badge.style.display = 'none';
        badge.setAttribute('aria-hidden', 'true');
        badge.textContent = '';
      }
    });

    // bullets
    updateBenefitPercents();
  }

  // Move Subscribe group above One-time group
  function reorderPlans(){
    var wrappers = document.querySelectorAll('[data-bundleapp-wrapper], .bundleapp-wrapper');
    wrappers.forEach(function(wrap){
      var one = wrap.querySelector('.bundleapp-plan-selector-group[data-one-time]');
      var sub = wrap.querySelector('.bundleapp-plan-selector-group:not([data-one-time])');
      if (one && sub && sub.nextSibling !== one){
        wrap.insertBefore(sub, one);
      }
    });
  }

  function wire(){
    document.addEventListener('change', function(e){
      if (e.target && (e.target.name === 'id' || e.target.closest?.('[name="id"]'))){
        updateAllBadges(); reorderPlans();
      }
    }, {passive:true});

    document.addEventListener('click', function(e){
      if (e.target.closest?.('[data-value]') || e.target.closest?.('[role="radio"]')){
        updateAllBadges(); reorderPlans();
      }
    }, {passive:true});

    document.addEventListener('variant:change', function(){ updateAllBadges(); reorderPlans(); });
    document.addEventListener('awtomic:purchaseOptionChange', function(){ updateAllBadges(); reorderPlans(); });
    document.addEventListener('shopify:section:load', function(){ updateAllBadges(); reorderPlans(); });
    window.addEventListener('pageshow', function(){ updateAllBadges(); reorderPlans(); });
    window.addEventListener('load', function(){ updateAllBadges(); reorderPlans(); });

    var ticking = false;
    new MutationObserver(function(){
      if (!ticking){
        ticking = true;
        requestAnimationFrame(function(){
          ticking = false;
          updateAllBadges(); reorderPlans();
        });
      }
    }).observe(document.documentElement, {childList:true, subtree:true, attributes:true});

    updateAllBadges(); reorderPlans();
    var n = 0, t = setInterval(function(){ n++; updateAllBadges(); reorderPlans(); if (n > 8) clearInterval(t); }, 400);
  }

  if (document.readyState !== 'loading') wire();
  else document.addEventListener('DOMContentLoaded', wire);
})();
